export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row rounded-2xl overflow-hidden bg-background-50 border border-background-200/70">
          <div className="lg:w-1/2 relative overflow-hidden min-h-[280px] md:min-h-[360px]">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20inviting%20modern%20desk%20setup%20with%20a%20laptop%20displaying%20colorful%20spreadsheet%20dashboard%20analytics%2C%20a%20steaming%20coffee%20cup%20beside%20it%2C%20small%20potted%20succulent%20plant%2C%20soft%20golden%20afternoon%20light%20streaming%20through%20sheer%20curtains%2C%20cream%20and%20warm%20beige%20tones%2C%20cozy%20productive%20atmosphere%2C%20editorial%20lifestyle%20photography%20with%20gentle%20bokeh%20background%2C%20home%20office%20aesthetic%20with%20personal%20touches&width=800&height=600&seq=cta-v2-litbuy&orientation=landscape"
                alt="Litbuy Spreadsheet productive workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50 hidden lg:block"></div>
          </div>

          <div className="lg:w-1/2 flex flex-col justify-center p-8 md:p-12">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              Ready to Get Started?
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              Discover the Full Litbuy Spreadsheet Collection
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              Browse the complete range of products and spreadsheet resources available at the official KA Spreadsheet store. From templates to tools, find everything you need to boost your productivity.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all text-center"
              >
                litbuy spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3 rounded-full bg-accent-500 text-background-50 font-semibold text-sm md:text-base whitespace-nowrap cursor-pointer hover:bg-accent-600 transition-all text-center"
              >
                Buy It Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}